import { CategoriesFiltersType } from '@components/catalog/category/grid/CategoriesFilter'
import { makeFilter, makeSearchFilter } from './crud/filters'



export const prepareCategoriesFilter = (filters: CategoriesFiltersType) => {
  const idsFilter = makeFilter('id', 'contains', filters.ids)
  const xidFilter = makeFilter('xid', 'contains', filters.xid)
  const searchFilter = makeSearchFilter('name', 'starts_with', filters.name)
  
  return {
    and: [
      idsFilter,
      xidFilter,
      searchFilter
    ]
  }
}